/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { ModuleWithProviders, NgModule } from '@angular/core';

import { NbSharedModule } from '../shared/shared.module';

import { NbChatComponent } from './chat.component';
import { NbChatMessageComponent } from './chat-message.component';
import { NbChatFormComponent } from './chat-form.component';
import { NbChatMessageTextComponent } from './chat-message-text.component';
import { NbChatMessageFileComponent } from './chat-message-file.component';
import { NbChatMessageQuoteComponent } from './chat-message-quote.component';
import { NbChatMessageMapComponent } from './chat-message-map.component';
import {NbChatMessageOptionsListComponent} from './chat-message-options-list.component';
import { NbChatOptions } from './chat.options';
import { NbChatMessageCustomComponent } from './chat-message-custom.component';

const NB_CHAT_COMPONENTS = [
  NbChatComponent,
  NbChatMessageComponent,
  NbChatFormComponent,
  NbChatMessageMapComponent,
  NbChatMessageTextComponent,
  NbChatMessageFileComponent,
  NbChatMessageQuoteComponent,
  NbChatMessageCustomComponent,
  NbChatMessageOptionsListComponent
];

@NgModule({
  imports: [
    NbSharedModule
  ],
  declarations: [
    ...NB_CHAT_COMPONENTS,
  ],
  exports: [
    ...NB_CHAT_COMPONENTS,
  ],
})
export class NbChatModule {

  static forRoot(options?: NbChatOptions) {
    return <ModuleWithProviders> {
      ngModule: NbChatModule,
      providers: [
        { provide: NbChatOptions, useValue: options },
      ],
    };
  }

  static forChild(options?: NbChatOptions) {
    return <ModuleWithProviders> {
      ngModule: NbChatModule,
      providers: [
        { provide: NbChatOptions, useValue: options },
      ],
    };
  }
}
